import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProjectList } from './project';
// import { DashboardEmployeeService } from '../dashboard-employee/dashboard-employee.service';
import { ProjectService } from './project.service';
import 'rxjs/add/operator/takeWhile';
import { SessionStorage } from 'ngx-webstorage';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.css']
})
export class ProjectComponent implements OnInit, OnDestroy {
  @SessionStorage() public user;
  @SessionStorage() public config;
  public myDatePickerOptions: IMyOptions;
  public myDatePickerEndOptions: IMyOptions;
  public startDate: any = '';
  public endDate: any = '';
  public startDatePicker: any = '';
  public endDatePicker: any = '';
  public projectlistarr: ProjectList[] = [];
  private alive: boolean = true; // A variable to unsubscribe the observable service call from Memory leak
  constructor(
    private projectsService: ProjectService,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar
  ) {
    const date: Date = new Date();
    date.setDate(date.getDate() + 1);

    this.myDatePickerOptions = {
      dateFormat: 'dd-mm-yyyy',
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };

    this.myDatePickerEndOptions = {
      dateFormat: 'dd-mm-yyyy',
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      inline: false,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };
  }

  ngOnInit() {
    this.getProjectLists();
  }

  /**function to get project list */
  getProjectLists() {
    this.projectlistarr = [];
    this.projectsService.getEmployeeProject(this.user.Empno, this.startDate, this.endDate).takeWhile(() => this.alive).subscribe((data) => {
      if (data.payload.length > 0) {
        data.payload.forEach(value => {
          this.projectlistarr.push(new ProjectList(value, this.config.businessUnit));
        });
      }
    });
  }

  /**function to set start and end date with validation */
  utilizationDatePicker() {
    const startDate = this.startDatePicker ? this.datePipe.transform(this.startDatePicker.jsdate, 'yyyy-MM-dd') : '';
    const endDate = this.endDatePicker ? this.datePipe.transform(this.endDatePicker.jsdate, 'yyyy-MM-dd') : '';
    if (startDate && endDate) {
      if (this.startDatePicker.epoc < this.endDatePicker.epoc) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.projectlistarr = [];
        this.getProjectLists();
      } else {
        this.snackBar.open('Please select the valid date range', 'OK', {
          duration: 3000
        });
      }
    } else if (!startDate && !endDate) {
      this.startDate = '';
      this.endDate = '';
      this.projectlistarr = [];
      this.getProjectLists();
    } else if (!endDate) {
      this.snackBar.open('Please select the end date', 'OK', {
        duration: 3000
      });
    } else if (!startDate) {
      this.snackBar.open('Please select the start date', 'OK', {
        duration: 3000
      });
    }
  }

  /**
   * @function ngOnDestroy()
   * @description
   * Function to destroy the Subscription used while calling API
   * Unsubscribe the observable is done using takeUntil method of rxjs
   * @author gaurav.rao
  */
  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/project/project.component.ts